// @flow

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { log } from '../../utils/jsUtils';

import TagsHeader from './TagsHeader';
import TagsContent from './TagsContent';
import MemberDrawer from '../MemberDrawer/index';
import Box from '@mui/material/Box';

import { useTheme } from '@mui/material/styles';
import tagsHomeStyles from './Styles/TagsHome.Style';


const TagsHome = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const usehandleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={tagsHomeStyles.root}>
      <Helmet>
        <title>Neo | Tags</title>
      </Helmet>
      <TagsHeader
        mobileOpen={mobileOpen}
        usehandleDrawerToggle={usehandleDrawerToggle}
      />
      
      <MemberDrawer 
        mobileOpen={mobileOpen} 
        usehandleDrawerToggle={usehandleDrawerToggle}
      />

      <TagsContent />
    </Box>
  );
};

export default TagsHome;

